﻿var ng;
(function () {
    'use strict';
    var controllerId = 'truckTrackingController';
    angular
        .module('app.controllers')
        .controller(controllerId, truckTrackingController);

    //$modal no existe cuando se vincula el bootstrap solo  
    truckTrackingController.$inject = ['common', 'datacontext', '$http', '$scope', '$translate', '$timeout', '$state', '$element', '$sce', '$window', '$stateParams', 'vsblockui', '$compile'];

    function truckTrackingController(common, datacontext, $http, $scope, $translate, $timeout, $state, $element, $sce, $window, $stateParams, vsblockui, $compile) {

        ng = $scope;

        var constantes = {
            QUANTITY_BASE_SCROLL: 13,
            CRITERIA_PATENT: 'P',
            CRITERIA_TRANSPORT_COMPANY: 'C',
            ROL_CARRIER: 'Carrier',
            ROL_TRUCKER: 'Trucker'
        };

        ng.spinnerOptions = {
            radius: 20,
            lines: 11,
            length: 1,
            width: 8,
            speed: 1.7,
            corners: 1.0,
            trail: 100,
            color: '#146794'
        };

        ng.sortDirection = "ASC";
        ng.sortField = "LicensePlateNo";
        ng.typeSearchModel = constantes.CRITERIA_PATENT;
        // Vistas
        ng.viewErrorInformation = false;
        ng.viewNoResultInformation = false;
        ng.viewEquipmentInformation = false;
        ng.actionSearch = false;
        ng.criteriaPatent = true;
        ng.transactionTypeList = [];
        ng.transactionType = 1;
        ng.displayInfoNoData = true;
        ng.disabledTransportCompany = false;

        ng.exportReport = function () {
            if (ng.nro_registros== 0) {
                toastr.info($translate.instant('views.stocksummary.noDataToExport'));
                return;
            }

            if (ng.typeSearchModel == constantes.CRITERIA_PATENT) {
                if (ng.patentSelected.originalObject != undefined) {
                    var model = {
                        patent: ng.patentSelected.originalObject.PatentNo,
                        codeRole: SecurityRolesResponse.code
                    }
                    datacontext.trucktracking.gettruckTrackingListExcel(model , "Seguimiento de Camiones");
                }
                
            }
            else {
                if (ng.transportCompanySelected.originalObject != undefined) {
                    var model = {
                        TransportCompanyId: ng.transportCompanySelected.originalObject.BusinessPartnerId,
                        ActualPosition: parseInt(ng.initialposition),
                        CountPartial: parseInt(ng.countPartial),
                        SortField: ng.sortField,
                        SortDirection: ng.sortDirection,
                        TransactionType: ng.transactionType
                    }
                    datacontext.trucktracking.gettruckTrackingByCompanyListExcel(model , "Seguimiento de Camiones");
                }

            }
        };

        function init() {
            var authData = common.localStorageService.get('authorizationData');
            var userRole = authData ? authData.userRole : "";
            if ((userRole == "SHI" || userRole == "Appointment") && authData.isOnlyPortalUser) {
                ng.disabledTransportCompany = true;
            }
            common.activateController([GetFilters()]).then(function (data) {
                setTransactionType(data[0]);
            },
                function (err) {
                    if (err.status)
                        toastr.error(err.info);
                });
        }

        init();

        var lbl_All = $translate.instant('views.appointment.all');
        /*---paginación----*/
        ng.total = 0;
        ng.countPartial = 10;
        ng.initialposition = 1;
        /*----------------*/
        ng.changeCriteria = function () {
            ng.nro_registros = 0;
            $scope.$broadcast('angucomplete-alt:clearInput');
            clearViews();

            switch (ng.typeSearchModel) {
                case constantes.CRITERIA_PATENT:
                    ng.criteriaPatent = true;
                    ng.criteriaTransportCompany = false;
                    break;
                case constantes.CRITERIA_TRANSPORT_COMPANY:
                    ng.criteriaPatent = false;
                    ng.criteriaTransportCompany = true;

                    if (IsTruckAndOnlyPortalUser()) {
                        var trucker = getTruckerAsociate();
                        ng.transportCompanySelected.originalObject = {
                            BusinessPartnerId: trucker.TruckerId, Name: trucker.Name
                        };

                        $("#transportCompanyAuto_value").val(ng.transportCompanySelected.originalObject.Name);
                        $("#transportCompanyAuto_value").attr('disabled', 'disabled');
                    }

                    break;
            }
        }        

        $scope.getPatentByNo = function (criteria) {
            return datacontext.trucktracking.getPatentByNo(criteria, SecurityRolesResponse.code);
        };

        ng.patentSelected = {};
        $scope.selectedPatentFn = function (selected) {
            if (selected != undefined) {
                ng.patentSelected = selected;
            }
            else {
                ng.patentSelected.originalObject = undefined;
            }
        }

        $scope.getTransportCompanyByName = function (criteria) {
            return datacontext.trucktracking.getTransportCompanyByName(criteria, SecurityRolesResponse.code);
        };

        ng.transportCompanySelected = {};
        $scope.selectedTransportCompanyFn = function (selected) {
            if (selected != undefined) {
                ng.transportCompanySelected = selected;
            }
            else {
                ng.transportCompanySelected.originalObject = undefined;
            }
        }

        ng.clear = function () {
            ng.typeSearchModel = constantes.CRITERIA_PATENT;
            ng.changeCriteria();
            $scope.selectedPatentFn(undefined);
            $scope.selectedTransportCompanyFn(undefined);
            ng.sortDirection = "ASC";
            ng.sortField = "LicensePlateNo";
            ng.transactionType = 1;
            ng.total = 0;
            ng.listTrucks = [];
            ng.displayInfoNoData = true;
        }

        ng.clickSearch = function () {
            ng.viewEquipmentInformation = false;
            ng.viewGridInformation = false;
            ng.viewNoResultInformation = false;
            if (ng.typeSearchModel == constantes.CRITERIA_PATENT) {
                if (ng.patentSelected.originalObject != undefined)
                    ng.getTruck(ng.patentSelected.originalObject.PatentNo, SecurityRolesResponse.code);
            }
            else {
                ng.listTrucks = [];
                if (ng.transportCompanySelected.originalObject != undefined) {
                    getTruckByTransportCompany(ng.transportCompanySelected.originalObject.BusinessPartnerId);
                }

            }
        }
        ng.onChangeSortDirection = function (item) {
            ng.sortDirection = item.currentTarget.attributes['id'].value;
            if (ng.transportCompanySelected.originalObject)
                getTruckByTransportCompany(ng.transportCompanySelected.originalObject.BusinessPartnerId);
        }

        ng.onChangeTransactionType = function (item) {
            ng.transactionType = item.currentTarget.attributes['transactiontypeid'].value;
            if (ng.transportCompanySelected.originalObject)
                getTruckByTransportCompany(ng.transportCompanySelected.originalObject.BusinessPartnerId);
        }

        ng.licensePlateNo = '';
        ng.companyName = '';
        ng.driverGTIName = '';
        ng.driverGTIDocumentNo = '';
        ng.driverTextGTI = '';
        ng.YardName = '';
        ng.driverGTOName = '';
        ng.driverGTODocumentNo = '';
        ng.driverTextGTO = '';
        ng.startDateGTI = '';
        ng.endDateGTI = '';
        ng.startDateGTO = '';
        ng.endDateGTO = '';
        ng.getTruck = function (patent, codeRole) {
            ng.actionSearch = true;
            var authData = common.localStorageService.get('authorizationData');
            return datacontext.trucktracking.getTruckByPatent(patent, codeRole).then(function (data) {
                if (data.Result == 1) {
                    if (data.Truck) {
                        ng.licensePlateNo = data.Truck.LicensePlateNo;
                        ng.companyName = data.Truck.CompanyName;
                        ng.driverGTIName = data.Truck.DriverGTIName;
                        ng.driverGTIDocumentNo = data.Truck.DriverGTIDocumentNo;
                        ng.driverTextGTI = (data.Truck.DriverGTIName != null ? data.Truck.DriverGTIName : "") + (data.Truck.DriverGTIDocumentNo != null ? " (" + data.Truck.DriverGTIDocumentNo + ")" : "");
                        ng.driverGTIName = data.Truck.DriverGTIName;
                        ng.YardName = data.Truck.YardName;
                        ng.driverGTODocumentNo = data.Truck.DriverGTODocumentNo;
                        ng.driverTextGTO = (data.Truck.DriverGTOName != null ? data.Truck.DriverGTOName : "") + (data.Truck.DriverGTODocumentNo != null ? " (" + data.Truck.DriverGTODocumentNo + ")" : "");
                        ng.startDateGTI = data.Truck.StartDateGTI;
                        ng.endDateGTI = data.Truck.EndDateGTI;
                        ng.startDateGTO = data.Truck.StartDateGTO;
                        ng.endDateGTO = data.Truck.EndDateGTO;
                        ng.viewEquipmentInformation = true;    
                        ng.nro_registros = 1;
                    }
                    
                }
                else {
                    ng.viewEquipmentInformation = false;
                    ng.viewGridInformation = false;
                    ng.viewNoResultInformation = true;
                }
                ng.actionSearch = false;
            },
                function (err) {
                    ng.actionSearch = false;
                    if (err.status)
                        toastr.error(err.info);
                });
        }

        ng.listTrucks = [];
        function getTruckByTransportCompany(idTransportCompany) {
            ng.actionSearch = true;
            ng.displayInfoNoData = false;
            var model = {
                TransportCompanyId: idTransportCompany,
                ActualPosition: parseInt(ng.initialposition),
                CountPartial: parseInt(ng.countPartial),
                SortField: ng.sortField,
                SortDirection: ng.sortDirection,
                TransactionType: ng.transactionType
            }
            return datacontext.trucktracking.getTruckByTransportCompany(model).then(function (data) {
                if (data.Result == 1) {
                    ng.listTrucks = data.Trucks;
                    ng.viewGridInformation = true;
                    ng.nro_registros = data.TotalCount;
                    ng.total = data.TotalCount;
                    if (data.totalCount == 0)
                        ng.displayInfoNoData = true;                    
                }
                else {
                    ng.viewEquipmentInformation = false;
                    ng.viewGridInformation = false;
                    ng.viewNoResultInformation = true;
                    ng.displayInfoNoData = true;
                }
                ng.actionSearch = false;
            },
                function (err) {
                    ng.actionSearch = false;
                    if (err.status)
                        toastr.error(err.info);
                });
        }

        function GetFilters() {
            return datacontext.trucktracking.getFilters();
        }

        function setTransactionType(data) {
            if (data) {
                data.TransactionTypes.push({ Id: 0, Code: lbl_All, Name: lbl_All });
                ng.transactionTypeList = data.TransactionTypes;
                data.TransactionTypes[0].isactive = 1;
                ng.transactionType = data.TransactionTypes[0].Id;
            }
        }

        ng.addScroll = function () {
            var scroll = '';
            if (ng.listTrucks.length >= constantes.QUANTITY_BASE_SCROLL) {
                scroll = 'table-y-400';
            }
            else {
                scroll = '';
            }
            return scroll;
        };

        function getTruckerAsociate() {
            var associateTrucker = common.localStorageService.get('GetBusinessPartnerUserRolesQuery');
            return {
                TruckerId: associateTrucker.BusinessPartnerId,
                Name: associateTrucker.Name,
                DocumentNumber: associateTrucker.DocumentNumber
            };
        }

        function IsTruckAndOnlyPortalUser() {
            var authData = common.localStorageService.get('authorizationData');
            var userRole = authData ? authData.userRole : "";

            return userRole == "TRU" && authData.isOnlyPortalUser ? true : false;
        }

        function clearViews() {
            ng.viewEquipmentInformation = false;
            ng.viewGridInformation = false;
            ng.viewNoResultInformation = false;
        }

    }
})();